import * as THREE from 'three';
import { useEffect, useState } from 'react';

export const BlackPlastic = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0,
  metalness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
  emissive: '#FFFFFF',
  emissiveIntensity: 0.15,
});

export const PaintColorMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0,
  metalness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
  emissive: '#FFFFFF',
  emissiveIntensity: 0.15,
  name: 'paint',
});

export const PaintColorMaterialDark = new THREE.MeshPhysicalMaterial({
  color: '#000000',
  roughness: 0,
  metalness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const WoodTopPaintColorMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0,
  metalness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
  emissive: '#FFFFFF',
  emissiveIntensity: 0.15,
  name: 'paint',
});

export const Mattress = new THREE.MeshPhysicalMaterial({
  color: '#eeeeee',
  roughness: 1,
  metalness: 0,
});

export const WoodTopMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
  // emissive: "#FFFFFF",
  // emissiveIntensity: 0,
});

export const Bronze = (envMap) =>
  new THREE.MeshPhysicalMaterial({
    color: '#695f49', // #5c5444
    roughness: 0.2,
    metalness: 1.0,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
    envMap,
  });

export const Silver = (envMap) =>
  new THREE.MeshPhysicalMaterial({
    color: '#A9A9A9', //#D3D3D3
    roughness: 0.3,
    metalness: 1.0,
    clearcoat: 0.5,
    clearcoatRoughness: 0.1,
    envMap,
  });

export const UpholsteryMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const LegFinishMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const CushionMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const ChairFrameMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const RetreatFabricMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const RetreatLegMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const TurnedLegMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const MetalLegMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const HeadboardFabricMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const Buffer = new THREE.MeshPhysicalMaterial({
  color: '#1f1f1f',
  roughness: 0.9,
  metalness: 0.75,
  clearcoat: 0.5,
  clearcoatRoughness: 0.5,
});

export const defaultMaterial = new THREE.MeshPhysicalMaterial({
  color: '#FFFFFF',
  roughness: 0.1,
  metalness: 0.1,
  clearcoat: 1,
  clearcoatRoughness: 0,
});

export const Chrome = (envMap) =>
  new THREE.MeshPhysicalMaterial({
    color: '#888888',
    roughness: 0,
    metalness: 1,
    clearcoat: 1,
    clearcoatRoughness: 0,
    envMap,
  });

export const Bedsheet = new THREE.MeshPhysicalMaterial({
  color: '#e8e8e8',
  roughness: 1,
  metalness: 0,
  clearcoat: 0,
  clearcoatRoughness: 0,
});

export const BlackFeet = new THREE.MeshPhysicalMaterial({
  color: '#000',
  roughness: 1,
  metalness: 0,
  clearcoat: 0.5,
  clearcoatRoughness: 0.5,
});

export const allFinishes = [
  { id: 1, value: 'Basket Weave : Milk' },
  { id: 2, value: 'Basket Weave : Vast Sky' },
  { id: 3, value: 'Beach House Linen : Peacock' },
  { id: 4, value: 'Beach House Linen : Vast Sky' },
  { id: 5, value: 'Boats By The Yard : Gladiola' },
  { id: 6, value: 'Boomerang : Cloud' },
  { id: 7, value: 'Boomerang: Sage' },
  { id: 8, value: 'Branch Out : Bermuda Beach' },
  { id: 9, value: 'Branch Out : Peacock' },
  { id: 10, value: 'Cast-A-Net : Wheatgrass' },
  { id: 11, value: 'Cast-A-Net : Lagoon' },
  { id: 12, value: 'Cast-A-Net : Marine' },
  { id: 13, value: 'Checkmate : Denim' },
  { id: 14, value: 'Checkmate : Sour Apple' },
  { id: 15, value: 'Clambake: Bluebell' },
  { id: 16, value: 'Clambake: Marine' },
  { id: 17, value: 'Clambake: Sprout' },
  { id: 18, value: 'Crazy Daisy : Nikko Blue' },
  { id: 19, value: 'Crazy Daisy : Wild Salmon' },
  { id: 20, value: 'Dilly : Bluebell' },
  { id: 21, value: 'Fireworks : Nikko Blue' },
  { id: 22, value: 'Fireworks : Wild Salmon' },
  { id: 23, value: 'Freckles : Greenery' },
  { id: 24, value: 'Freckles : Skyline' },
  { id: 25, value: 'Freckles : Zinnia' },
  { id: 26, value: 'Grand Mum : Oyster' },
  { id: 27, value: 'Grand Mum : Sun' },
  { id: 28, value: 'Hotty Dotty : Ale' },
  { id: 29, value: 'Hydrangea Holiday : Bluestone' },
  { id: 30, value: 'Hydrangea Holiday : Marine' },
  { id: 31, value: 'In Stitches : Bluebell' },
  { id: 32, value: 'Knotty Loop : Academy' },
  { id: 33, value: 'Knotty Loop : Bluestone' },
  { id: 34, value: 'Knotty Loop : Marine' },
  { id: 35, value: 'Laguna : Marine' },
  { id: 36, value: 'Laguna : Pear' },
  { id: 37, value: 'Lavishly : Marine' },
  { id: 38, value: 'Lavishly : Shortcake' },
  { id: 39, value: 'Lavishly : Skyline' },
  { id: 40, value: 'Leaflette : Marine' },
  { id: 41, value: 'Leaflette : Porch' },
  { id: 42, value: "Let's Grove : Marine" },
  { id: 43, value: "Let's Grove : Sage" },
  { id: 44, value: 'Lucky Leaf : Marine' },
  { id: 45, value: 'Mix Tape : Lagoon' },
  { id: 46, value: 'Mix Tape : Marine' },
  { id: 47, value: 'Mix Tape : Ryegrass' },
  { id: 48, value: 'Mix Tape : Storm' },
  { id: 49, value: 'Oxford Stripe : Greenery' },
  { id: 50, value: 'Oxford Stripe : Marine' },
  { id: 51, value: 'Oxford Stripe : Oyster' },
  { id: 52, value: 'Oxford Stripe : Zinnia' },
  { id: 53, value: 'Pebble Washed : Bisque' },
  { id: 54, value: 'Pebble Washed : Sage' },
  { id: 55, value: 'Plain Jane : Academy' },
  { id: 56, value: 'Plain Jane : Bisque' },
  { id: 57, value: 'Plain Jane : Bluestone' },
  { id: 58, value: 'Plain Jane : Bright White' },
  { id: 59, value: 'Plain Jane : Skyline' },
  { id: 60, value: 'Plain Jane : Surf' },
  { id: 61, value: 'Raine : Academy' },
  { id: 62, value: 'Raine : Good Egg' },
  { id: 63, value: 'Raine : Lagoon' },
  { id: 64, value: 'Raine : Wheatgrass' },
  { id: 65, value: 'Sea Biscuit : Bluestone' },
  { id: 66, value: 'Sea Biscuit : Oyster' },
  { id: 67, value: 'Sea Biscuit : Porch' },
  { id: 68, value: 'Sea Biscuit : True Blue' },
  { id: 69, value: 'Shabby Stripes : Bluestone' },
  { id: 70, value: 'Shell Game : Lagoon' },
  { id: 71, value: 'Shell Game : Marine' },
  { id: 72, value: 'Shore-Bet : Winter' },
  { id: 73, value: 'Shore-Bet : Bermuda Beach' },
  { id: 74, value: 'Shore-Bet : Bluebell' },
  { id: 75, value: 'Shore-Bet : Bright White' },
  { id: 76, value: 'Shore-Bet : Nantucket' },
  { id: 77, value: 'Shore-Bet : Sprout' },
  { id: 78, value: 'Shore-Bet : Surf' },
  { id: 79, value: 'Shore-Bet : Vast Sky' },
  { id: 80, value: 'Simply Soft : Cloud' },
  { id: 81, value: 'Simply Soft : Marine' },
  { id: 82, value: 'Simply Soft : Oyster' },
  { id: 83, value: 'Thatch : Bluebell' },
  { id: 84, value: 'Thread Up : Shortcake' },
  { id: 85, value: 'Tweedy : Bisque' },
  { id: 86, value: 'Tweedy : Bluestone' },
  { id: 87, value: 'Tweedy : Oyster' },
  { id: 88, value: 'Tweet Suite: Porch' },
  { id: 89, value: 'Very Velvet : Marine' },
  { id: 90, value: 'Very Velvet : Sage' },
  { id: 91, value: 'Washed Out : Vast Sky' },
  { id: 92, value: 'Well-Worn : Vast Sky' },
  { id: 93, value: 'Zig Zag : Cloud' },
  { id: 94, value: 'Zig Zag : Skyline' },
  { id: 95, value: 'Bronzed Metal' },
  { id: 96, value: 'Slate Metal' },
  { id: 97, value: 'Academy' },
  { id: 98, value: 'Bermuda Beach' },
  { id: 99, value: 'Bisque' },
  { id: 100, value: 'Blackbird' }, // #13171c
  { id: 101, value: 'Bluebell' },
  { id: 102, value: 'Bluestone' },
  { id: 103, value: 'Bright White' },
  { id: 104, value: 'Cloud' },
  { id: 105, value: 'Gladiola' },
  { id: 106, value: 'Joy' },
  { id: 107, value: 'Lagoon' },
  { id: 108, value: 'Marine' },
  { id: 109, value: 'Milk' },
  { id: 110, value: 'Oyster' },
  { id: 111, value: 'Peacock' },
  { id: 112, value: 'Porch' },
  { id: 113, value: 'Rhubarb' },
  { id: 114, value: 'Ryegrass' },
  { id: 115, value: 'Sage' },
  { id: 116, value: 'Shortcake' },
  { id: 117, value: 'Skyline' },
  { id: 118, value: 'Slate' },
  { id: 119, value: 'Sorbet' },
  { id: 120, value: 'Sprout' },
  { id: 121, value: 'Storm' },
  { id: 122, value: 'Sun' },
  { id: 123, value: 'Surf' },
  { id: 124, value: 'Tomato' },
  { id: 125, value: 'Vast Sky' },
  { id: 126, value: 'Zinnia' },
  { id: 127, value: 'Hand Planed Bourbon Cherry' },
  { id: 128, value: 'Natural Cherry' },
  { id: 129, value: 'Natural Maple' },
  { id: 130, value: 'Natural Quarter Sawn White Oak' },
  { id: 131, value: 'Matte Glazed White Oak' },
  { id: 132, value: 'Natural cherry' },
  { id: 133, value: 'Coconut Husk' },
  { id: 134, value: 'Fruitwood' },
  { id: 135, value: 'Java' },
  { id: 136, value: 'Limewash' },
  { id: 137, value: 'Natural Maple' },
  { id: 138, value: 'Nordic' },
  { id: 139, value: 'Sea Salt' },
  { id: 140, value: 'No Cushion' },
  { id: 141, value: 'Painted' },
];
